import { manageAxios } from "@/config/axios";
import { AxiosResponse } from "axios";

export function createWorkOrder(data: any, params?: {}): Promise<AxiosResponse<any>> {
    return manageAxios.post(`/create-order`, data, {
        params: {
            ...params,
        }
    })
}
